import { render } from "./BudgetPolicy.vue?vue&type=template&id=e82d27c0"
import script from "./BudgetPolicy.vue?vue&type=script&lang=js"
export * from "./BudgetPolicy.vue?vue&type=script&lang=js"

import "./BudgetPolicy.vue?vue&type=style&index=0&id=e82d27c0&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__